/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.37
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { AudienceEnum } from '../model/models';
import { Problem } from '../model/models';
import { SituationCauseEnum } from '../model/models';
import { SituationResponse } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class SituationsV3Service {

    protected basePath = 'https://journey-service.api.sbb.ch';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Get situation-messages by Id (referencing HIM messages).
     * Lists active situation-messages within a publication window provided by SBB HIM.
     * @param ids Set of HIM-Ids ([1..50]).
     * @param requestID The given \&#39;Request-ID\&#39; will support traceability (monitoring by Instana and logging by Splunk). The given value will be returned by the appropriate response as well (see [SBB Instana](https://confluence.sbb.ch/display/MON/Instana+-+HTTP+Header+Whitelist)).
     * @param acceptLanguage Language of translatable properties.
     * @param audience Restricts situation-filter to wanted reader like end-user\&#39;s (B2C), or staff like SBB employees (B2E) for consuming publishing-channels, where:&lt;br&gt;x-extensible-enum:  - B2C_TEXT represents end-user messages - B2C_MAP as on map \&#39;de:Bahnverkehrsinformationskarte\&#39; with icons and coordinates - B2C_TIMETABLE journey related passenger message (as found for e.g. on a public transportation leg) - B2E_TEXT represent sales staff messages - B2E_MAP represent sales staff map
     * @param includeProjection Relates to &#x60;audience&#x3D;*_MAP&#x60; otherwise ignored! With or without a plottable polyline for each situation-message related element (if available for edges and regions).&lt;br&gt;This parameter has an impact on performance and/or response volume, set wisely!
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSituationsByIds(ids: Array<string>, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', audience?: AudienceEnum, includeProjection?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<SituationResponse>;
    public getSituationsByIds(ids: Array<string>, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', audience?: AudienceEnum, includeProjection?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<HttpResponse<SituationResponse>>;
    public getSituationsByIds(ids: Array<string>, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', audience?: AudienceEnum, includeProjection?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<HttpEvent<SituationResponse>>;
    public getSituationsByIds(ids: Array<string>, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', audience?: AudienceEnum, includeProjection?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<any> {
        if (ids === null || ids === undefined) {
            throw new Error('Required parameter ids was null or undefined when calling getSituationsByIds.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (audience !== undefined && audience !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>audience, 'audience');
        }
        if (includeProjection !== undefined && includeProjection !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>includeProjection, 'includeProjection');
        }

        let headers = this.defaultHeaders;
        if (requestID !== undefined && requestID !== null) {
            headers = headers.set('Request-ID', String(requestID));
        }
        if (acceptLanguage !== undefined && acceptLanguage !== null) {
            headers = headers.set('Accept-Language', String(acceptLanguage));
        }

        let credential: string | undefined;
        // authentication (BearerAuth) required
        credential = this.configuration.lookupCredential('BearerAuth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/problem+json',
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<SituationResponse>(`${this.configuration.basePath}/v3/situations/${encodeURIComponent(String(ids))}`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get &#x60;PTSituationMessage\&#39;s&#x60; by RSS-Feed.
     * Lists active situation-messages within a publication window provided by SBB HIM. Format: RSS-Feed (type RSS 2.0) as an XML body, see [Web content: Really Simple Syndication](https://validator.w3.org/feed/docs/rss2.html#requiredChannelElements).
     * @param requestID The given \&#39;Request-ID\&#39; will support traceability (monitoring by Instana and logging by Splunk). The given value will be returned by the appropriate response as well (see [SBB Instana](https://confluence.sbb.ch/display/MON/Instana+-+HTTP+Header+Whitelist)).
     * @param acceptLanguage Language of translatable properties.
     * @param language Language of translatable properties. Overrides the Accept-Language header which is not suitable for some clients.&lt;br&gt;x-extensible-enum: see allowable values
     * @param causes PTSituation::cause (aka HIM category).&lt;br&gt;x-extensible-enum: (see &#x60;SituationCauseEnum&#x60; except \&#39;VOCAL_ANNOUNCEMENT_ON_VEHICLE\&#39;), or analog as raw values [0..5]
     * @param audience Restricts situation-filter to wanted reader like end-user\&#39;s (B2C), or staff like SBB employees (B2E) for consuming publishing-channels, where:&lt;br&gt;x-extensible-enum:  - B2C_TEXT represents end-user messages - B2C_MAP as on map \&#39;de:Bahnverkehrsinformationskarte\&#39; with icons and coordinates - B2C_TIMETABLE journey related passenger message (as found for e.g. on a public transportation leg) - B2E_TEXT represent sales staff messages - B2E_MAP represent sales staff map
     * @param priorityMin Search interval minimal **numerical value** for &#x60;PTSituationMessage::priority&#x60; and relates to &#x60;priorityMax&#x60;.&lt;br&gt;The **semantic value** is to be understood vice versa to the numerical value, like: Priority rank (the smaller the higher): low &#x3D; 80, medium &#x3D; 60, high &#x3D; 40, de:Grossereignis &#x3D; 20
     * @param priorityMax Search interval maximal **numerical value** for &#x60;PTSituationMessage::priority&#x60;, relates to &#x60;priorityMin&#x60;.
     * @param affectedRegions Filter situations for specific regions (see AffectedRegion::nameFormatted, ::name&#x60;).&lt;br&gt;x-extensible-enum: [CH_WEST,CH_MID,CH_ZURICH,CH_TICINO,CH_EAST,FRANCE,GERMANY,AUSTRIA,ITALY] (or analog as HIM raw values [BVI1,BVI2,BVI3,BVI4,BVI5,CSTRI1,CSTRI2,CSTRI3,CSTRI4])
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSituationsByRSSFeed(requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', language?: 'de' | 'fr' | 'it' | 'en', causes?: Array<string>, audience?: AudienceEnum, priorityMin?: number, priorityMax?: number, affectedRegions?: Array<string>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'text/xml; charset&#x3D;utf-8'}): Observable<string>;
    public getSituationsByRSSFeed(requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', language?: 'de' | 'fr' | 'it' | 'en', causes?: Array<string>, audience?: AudienceEnum, priorityMin?: number, priorityMax?: number, affectedRegions?: Array<string>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'text/xml; charset&#x3D;utf-8'}): Observable<HttpResponse<string>>;
    public getSituationsByRSSFeed(requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', language?: 'de' | 'fr' | 'it' | 'en', causes?: Array<string>, audience?: AudienceEnum, priorityMin?: number, priorityMax?: number, affectedRegions?: Array<string>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'text/xml; charset&#x3D;utf-8'}): Observable<HttpEvent<string>>;
    public getSituationsByRSSFeed(requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', language?: 'de' | 'fr' | 'it' | 'en', causes?: Array<string>, audience?: AudienceEnum, priorityMin?: number, priorityMax?: number, affectedRegions?: Array<string>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/problem+json' | 'text/xml; charset&#x3D;utf-8'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (language !== undefined && language !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>language, 'language');
        }
        if (causes) {
            causes.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'causes');
            })
        }
        if (audience !== undefined && audience !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>audience, 'audience');
        }
        if (priorityMin !== undefined && priorityMin !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>priorityMin, 'priorityMin');
        }
        if (priorityMax !== undefined && priorityMax !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>priorityMax, 'priorityMax');
        }
        if (affectedRegions) {
            affectedRegions.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'affectedRegions');
            })
        }

        let headers = this.defaultHeaders;
        if (requestID !== undefined && requestID !== null) {
            headers = headers.set('Request-ID', String(requestID));
        }
        if (acceptLanguage !== undefined && acceptLanguage !== null) {
            headers = headers.set('Accept-Language', String(acceptLanguage));
        }

        let credential: string | undefined;
        // authentication (BearerAuth) required
        credential = this.configuration.lookupCredential('BearerAuth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/problem+json',
                'text/xml; charset=utf-8'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<string>(`${this.configuration.basePath}/v3/situations/by-rss-feed`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get situation-messages within the given time interval.
     * Lists active situation-messages within a publication window provided by SBB HIM.
     * @param requestID The given \&#39;Request-ID\&#39; will support traceability (monitoring by Instana and logging by Splunk). The given value will be returned by the appropriate response as well (see [SBB Instana](https://confluence.sbb.ch/display/MON/Instana+-+HTTP+Header+Whitelist)).
     * @param acceptLanguage Language of translatable properties.
     * @param validFromDate Begin publishing window of situation validity (related to &#x60;validFromTime&#x60; and &#x60;validToDate&#x60;/&#x60;validToTime&#x60;), defaults to TODAY.
     * @param validFromTime Begin of publishing window of situation validity (related to &#x60;validFromDate&#x60; and &#x60;validToDate&#x60;/&#x60;validToTime&#x60;), defaults to NOW (seconds will be ignored).
     * @param validToDate End of publishing window of situation validity (related to &#x60;validToTime&#x60; and &#x60;validFromDate&#x60;/&#x60;validFromTime&#x60;), defaults to TODAY.
     * @param validToTime End of publishing window of situation validity (related to &#x60;validToDate&#x60; and &#x60;validFromDate&#x60;/&#x60;validToTime&#x60;), defaults to NOW (seconds will be ignored).
     * @param affectedScope Specific business use case. If MAJOR_AREA_DISRUPTION is set, some filters might be ignored (J-S will adapt to latest P Data-Mgmt rules automatically)!
     * @param cause An event inducing a change resp. disruption in public transport or traffic operation (aka HIM category).
     * @param audience Restricts situation-filter to wanted reader like end-user\&#39;s (B2C), or staff like SBB employees (B2E) for consuming publishing-channels, where:&lt;br&gt;x-extensible-enum:  - B2C_TEXT represents end-user messages - B2C_MAP as on map \&#39;de:Bahnverkehrsinformationskarte\&#39; with icons and coordinates - B2C_TIMETABLE journey related passenger message (as found for e.g. on a public transportation leg) - B2E_TEXT represent sales staff messages - B2E_MAP represent sales staff map
     * @param title Post-filters text contained in &#x60;title&#x60; of message (related to Accept-Language).
     * @param priorityMin Search interval minimal **numerical value** for &#x60;PTSituationMessage::priority&#x60; and relates to &#x60;priorityMax&#x60;.&lt;br&gt;The **semantic value** is to be understood vice versa to the numerical value, like: Priority rank (the smaller the higher): low &#x3D; 80, medium &#x3D; 60, high &#x3D; 40, de:Grossereignis &#x3D; 20&lt;br&gt;(Patch applied for confusing case: if only the min value is set and greater than 40, the &#x60;priorityMin&#x60; will become 0 and &#x60;priorityMax&#x60; will become this value to build the search interval.)
     * @param priorityMax Search interval maximal **numerical value** for &#x60;PTSituationMessage::priority&#x60;, relates to &#x60;priorityMin&#x60;.&lt;br&gt;(See applied patch in &#x60;priorityMin&#x60;.)
     * @param includeProjection Relates to &#x60;audience&#x3D;*_MAP&#x60; otherwise ignored! With or without a plottable polyline for each situation-message related element (if available for edges and regions).&lt;br&gt;This parameter has an impact on performance and/or response volume, set wisely!
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSituationsByValidity(requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', validFromDate?: string, validFromTime?: string, validToDate?: string, validToTime?: string, affectedScope?: 'MAJOR_AREA_DISRUPTION', cause?: SituationCauseEnum, audience?: AudienceEnum, title?: string, priorityMin?: number, priorityMax?: number, includeProjection?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<SituationResponse>;
    public getSituationsByValidity(requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', validFromDate?: string, validFromTime?: string, validToDate?: string, validToTime?: string, affectedScope?: 'MAJOR_AREA_DISRUPTION', cause?: SituationCauseEnum, audience?: AudienceEnum, title?: string, priorityMin?: number, priorityMax?: number, includeProjection?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<HttpResponse<SituationResponse>>;
    public getSituationsByValidity(requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', validFromDate?: string, validFromTime?: string, validToDate?: string, validToTime?: string, affectedScope?: 'MAJOR_AREA_DISRUPTION', cause?: SituationCauseEnum, audience?: AudienceEnum, title?: string, priorityMin?: number, priorityMax?: number, includeProjection?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<HttpEvent<SituationResponse>>;
    public getSituationsByValidity(requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', validFromDate?: string, validFromTime?: string, validToDate?: string, validToTime?: string, affectedScope?: 'MAJOR_AREA_DISRUPTION', cause?: SituationCauseEnum, audience?: AudienceEnum, title?: string, priorityMin?: number, priorityMax?: number, includeProjection?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (validFromDate !== undefined && validFromDate !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>validFromDate, 'validFromDate');
        }
        if (validFromTime !== undefined && validFromTime !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>validFromTime, 'validFromTime');
        }
        if (validToDate !== undefined && validToDate !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>validToDate, 'validToDate');
        }
        if (validToTime !== undefined && validToTime !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>validToTime, 'validToTime');
        }
        if (affectedScope !== undefined && affectedScope !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>affectedScope, 'affectedScope');
        }
        if (cause !== undefined && cause !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>cause, 'cause');
        }
        if (audience !== undefined && audience !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>audience, 'audience');
        }
        if (title !== undefined && title !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>title, 'title');
        }
        if (priorityMin !== undefined && priorityMin !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>priorityMin, 'priorityMin');
        }
        if (priorityMax !== undefined && priorityMax !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>priorityMax, 'priorityMax');
        }
        if (includeProjection !== undefined && includeProjection !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>includeProjection, 'includeProjection');
        }

        let headers = this.defaultHeaders;
        if (requestID !== undefined && requestID !== null) {
            headers = headers.set('Request-ID', String(requestID));
        }
        if (acceptLanguage !== undefined && acceptLanguage !== null) {
            headers = headers.set('Accept-Language', String(acceptLanguage));
        }

        let credential: string | undefined;
        // authentication (BearerAuth) required
        credential = this.configuration.lookupCredential('BearerAuth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/problem+json',
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<SituationResponse>(`${this.configuration.basePath}/v3/situations/by-validity`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
